<template>
  <div class="notice_maxbox">

    <!-- 分割线 -->
    <div class="cut_off"></div>

    <!-- 内容： -->
    <div class="notice_box">
      <div class="notice" v-show="listTF">
        <!-- 标题： -->
        <h3>平台公告：</h3>
        <!-- 内容： -->
        <div>
          <p class="p_div" v-for="item in list" :key="item.id" @click="noticeFun(item)">
            <span>{{item.title}}</span>
            <span>{{item.createtime}}</span>
          </p>
        </div>
        <!--  -->
      </div>
      <!--  -->
      <notice-content v-show="!listTF" :contents="contents" ></notice-content>
    </div>
    <!-- END-内容 -->

  </div>
</template>

<script>
import axios from 'axios';
import NoticeContent from './NoticeContent.vue';

export default {
  name: 'Notice',
  props: {

  },
  data() {
    return {
      list: [],
      contents: [],
      listTF: true,
    }
  },
  components: {
    NoticeContent
  },
  computed: {

  },
  methods: {
    noticeFun(item){
      this.contents = item;
      this.listTF = false;
      // console.log(this.contents);
    }
  },
  mounted() {
    // 有用：title，content，content：
    axios.get(this.$store.state.axiosNoticeUrl, {
            params: {
              // action: 1,
              // uid: this.$store.state.uid
            }
          }).then( res =>{
            // console.log(res.data.message);
            this.list = res.data.message;
          })
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* 分割线 */
  .cut_off {
    height: 4px;
    background: #e73262;
  }
  /* 内容： */
  .notice_box {
    box-sizing: border-box;
    color: #000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 550px;
    padding: 50px 0;
  }
  .notice {
    /* display: flex; */
    box-sizing: border-box;
    border: 1px solid #cccccc;
    border-radius: 8px;
    padding: 12px;
    width: 1200px;
  }
  .notice >h3 {
    border-left: 8px solid #e73262;
    padding-left: 4px;
    font-size: 17px;
    box-sizing: border-box;
    /* font-weight: bold; */
    /* margin: 6px; */
  }
  .notice >div {
    box-sizing: border-box;
    padding: 16px;
  }
  .p_div {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 16px 4px;
    cursor: pointer;
  }
  .p_div+.p_div {
    border-top: 1px solid #cccccc;
  }
</style>